import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import { Component } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import ServicoEntregaModel from "@/models/servicoEntregaModel";
import LocalEntregaModel from "@/models/transporte/localEntregaModel";
import TransportadoraModel from "@/models/transporte/transportadoraModel";
import ServicoEntregaService from "@/services/servicoEntregaService";
import localEntregaService from "@/services/transporte/localEntregaService";
import TransportadoraService from "@/services/transporte/transportadoraService";
import { getServicoEntregaCombo } from "@/utils/common/combo/combotext";

import EditComponentBase from "../editComponentBase";

const transportadoraService = new TransportadoraService();
const servicoEntregaService = new ServicoEntregaService();

@Component({
    components: {
        comboComponent,
        moedaComponent,
        checkboxComponent,
    },
})
export default class LocalEntregaEditComponent extends EditComponentBase<LocalEntregaModel> {
    transportadoraOptions: Array<Object> = [];
    servicoEntregaOptions: Array<Object> = [];

    private async loadTransportadora() {
        try {
            const data = await transportadoraService.combo().resolveWithJSON<PaginationModel<TransportadoraModel>>();
            this.transportadoraOptions = data.list.map(p => ({ value: p.id, text: p.nome }));
        } catch {}
    }

    private async loadServicoEntrega() {
        try {
            const data = await servicoEntregaService.combo().resolveWithJSON<PaginationModel<ServicoEntregaModel>>();
            this.servicoEntregaOptions = data.list.map(getServicoEntregaCombo);
        } catch {}
    }

    private async beforeMount() {
        await this.setPropsCached(localEntregaService, "local_de_entrega", new LocalEntregaModel());

        Promise.all([this.loadTransportadora(), this.loadServicoEntrega()]).withLoading();
    }

    public async afterMounted() {
        if (!this.modelId) {
            this.model["codigo"] = await localEntregaService.getProximoCodigo().resolveWithJSON<number>();
        }
    }
}
